import key from '../config/config';
import * as api from "../routes/userroutefront";
import axios, { setAuthorization } from "../config/axios";



export const getFaq = async (data, dispatch) => {
    try {
        let respData = await axios({
            'url': key.API_URL + api.getFaq,
            'method': 'get'
        });

        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
            result: respData?.data?.result
        }
    }
    catch (err) {
        // console.log(err, 'getFaq_error')
        return {
            status: err?.response?.data?.status,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}


export const addNewsLetterUser = async (data) => {
    try {
        let respData = await axios({
            'url': key.API_URL + api.newsLetterUserAdd,
            'method': 'post',
            'data': data
        });
        return {
            status: respData?.data?.status,
            message: respData?.data?.result?.messages,
            result: respData?.data?.result
        }
    }
    catch (err) {
        // console.log(err, 'addNewsLetterUser_error')
        return {
            status: err?.response?.data?.status,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}